module.exports = __webpack_public_path__ + "images/kunden/saubere_filme_kunden_logo_pfizer.png";